module.exports = __webpack_public_path__ + "img/dashboard.9cf3b62c.jpg";